<template>

<div class="content">

   <el-card class="box-card BoxDetailFiltre">
         <el-form ref="form" :model="sizeForm" label-width="120px" size="mini">
           
                    <el-row class="ligneActFiltre">
                                <el-col class="ColonneGauche" :span="2" style="margin-left:100px ;margin-top:60px">
                                    <span>
                                    Commercial
                                    </span>
                                </el-col>
                                <el-col :span="3">
                                    <el-select v-model="nom_com" size='mini' style="margin-left:50px;margin-top:60px;width:300px" placeholder="Veuillez sélectionner un commercial" class="selectColDroite2">
                                    </el-select>
                                </el-col>
                    </el-row>
             

                   <el-row class="ligneActFiltre">
                                <el-col class="ColonneGauche" :span="2" style="margin-left:100px;margin-top:20px">
                                    <span>
                                Client
                                    </span>
                                </el-col>
                                <el-col :span="3">
                                    <el-select v-model="nom_com" size='mini' style="margin-left:50px;margin-top:20px;width:300px" placeholder="Veuillez sélectionner un client" class="selectColDroite2">
                                    </el-select>
                                </el-col>
                    </el-row>

                    <el-row class="ligneActFiltre">
                                <el-col class="ColonneGauche" :span="2" style="margin-left:100px;margin-top:20px">
                                    <span>
                                Secteur
                                    </span>
                                </el-col>
                                <el-col :span="3">
                                    <el-select v-model="nom_com" size='mini' style="margin-left:50px;margin-top:20px;width:300px" placeholder="Veuillez sélectionner un secteur" class="selectColDroite2">
                                    </el-select>
                                </el-col>
                    </el-row>
                    <el-row class="ligneActFiltre">
                                <el-col class="ColonneGauche" :span="2" style="margin-left:100px;margin-top:20px">
                                    <span>
                                Objet
                                    </span>
                                </el-col>
                                <el-col :span="3">
                                    <el-select v-model="nom_com" size='mini' style="margin-left:50px;margin-top:20px;width:300px" placeholder="Veuillez sélectionner un objet" class="selectColDroite2">
                                    </el-select>
                                </el-col>
                    </el-row>

                    <el-row class="ligneActFiltre">
                                <el-col class="ColonneGauche" :span="2" style="margin-left:100px;margin-top:20px">
                                    <span>
                                Action en cours
                                    </span>
                                </el-col>
                                <el-col :span="3">
                                    <el-select v-model="nom_com" size='mini' style="margin-left:50px;margin-top:20px;width:300px" placeholder="Veuillez sélectionner une action en cours" class="selectColDroite2">
                                    </el-select>
                                </el-col>
                    </el-row>
                    <el-row class="ligneActFiltre">
                                <el-col class="ColonneGauche" :span="2" style="margin-left:100px ;margin-top:20px">
                                    <span>
                                Action cloturée
                                    </span>
                                </el-col>
                                <el-col :span="3">
                                    <el-select v-model="nom_com" size='mini' style="margin-left:50px;margin-top:20px;width:300px" placeholder="Veuillez sélectionner action cloturée" class="selectColDroite2">
                                    </el-select>
                                </el-col>
                    </el-row>

                <el-row class="ligneActFiltre">
                                <el-col class="ColonneGauche" :span="2" style="margin-left:100px ;margin-top:20px">
                                    <span>
                                    Date Début
                                    </span>
                                </el-col>
                                <el-col :span="3">
                                    <el-date-picker size='mini' v-model="dte_prev" id='detail_dte_prev' style="margin-left:50px ;margin-top:20px;width:300px"
                                        class="selectColDroite" type="datetime" placeholder="Date et heure"
                                        value-format="dd-MM-yyyy HH:mm" format="dd-MM-yyyy HH:mm" @change='handleDtePrev'
                                        @blur='handleblurDtePrev'>
                                    </el-date-picker>
                                </el-col>
               </el-row>
                <el-row class="ligneActFiltre">
                                <el-col class="ColonneGauche" :span="2" style="margin-left:100px ;margin-top:20px">
                                    <span>
                                    Date Fin
                                    </span>
                                </el-col>
                                <el-col :span="2">
                                    <el-date-picker size='mini' v-model="dte_prev" id='detail_dte_prev' style="margin-left:50px ;margin-top:20px;width:300px"
                                        class="selectColDroite" type="datetime" placeholder="Date et heure"
                                        value-format="dd-MM-yyyy HH:mm" format="dd-MM-yyyy HH:mm" @change='handleDtePrev'
                                        @blur='handleblurDtePrev'>
                                    </el-date-picker>
                                </el-col>
                </el-row>
        
            <el-row class="ligneActFiltre">
                 <el-col class="ColonneGauche" :span="1" style="margin-left:350px ;margin-top:40px">
                        <el-button
                            type="primary"
                            size="small "
                            id="delete_filtre"
                            icon="el-icon-check"
                            @click="handle_delete_filtre">Effacer les filtres
                      </el-button>
                  </el-col>

                <el-col class="ColonneGauche" :span="1" style="margin-left:110px ;margin-top:40px">
                    <el-button 
                         type="primary" 
                        size="small "
                        id="delete_filtre"
                        @click="handle_delete_filtre">Valider
                    </el-button>
              </el-col>
          </el-row>
      </el-form>
</el-card>
</div>
</template>


// Action
margin-left:50px;
 <!-- <el-input type="text" v-model="montant" size='mini' placeholder="" class="selectColDroite2" ref='DEVIS' @change='handleUpdateDEVIS()'>
                               <el-option :key='null' :label='null' :value='null'></el-option>
                                <el-option v-for="item in action.DEVIS" :key="item.MONTANT" :label="item.MONTANT"
                                    :value="item.MONTANT">
                                </el-option>
                            </el-input>  -->


<script>


        import axios from 'axios';
        import $ from 'jquery';
        import {BACKEND_URL} from './GLOBALS'
        //   import ElementUI from 'element-ui';
        // import 'element-ui/lib/theme-chalk/index.css';
        // import enLocale from 'element-ui/lib/locale/lang/fr'
    //       style="margin-right:920px ;margin-top:50px" 
        
        
        import Vue from 'vue'
        
        const moment = require('moment')
        require('moment/locale/fr')

        Vue.use(require('vue-moment'), {
            moment
        }) 
        
        export default {
            name:'Filtre_Action',
            components: {
            },
            data () {
            return {
              
               publicPath: process.env.BASE_URL,
            optionFrequence:['Mois','Trimestre','Semestre'],
                editor: ClassicEditor,      
                editorConfig: {
                    // The configuration of the editor.
                },
         activeName:'detail',
       
         numAct:{},
         action:{},
          tabPosition: 'top',
        interlocuteurs: {
       interlocuteurs_ID: []
        },
        nom_cli:'',
        nom_com:'',
        objet:'',
        frequence:'',
        etat:'',
        priorite: '',
        dte_creat:'',
        dte_prev:'',
        dte_real:'',
        commentCompteRend:'',
        commentPrep:'',
        nature:'',
        origine:'',
        interet:'',
        statut:'',
        echeance:'',
        NUM_AFFAIRE:'',
        reactiviteDetail:'',
        rencontre:'',

         optionsNom_Cli: [{
            value: 'nom_cli',
            label: ''
        }],
        optionsPriorite:'',
        optionsObjet:'',
        optionsNature:'',
        optionsOrigine:'',
        optionsInteret:'',
        optionsStatut: '',

        nom: '',
        listeInterlocteurs: '',
        dialogFormInterlocuteurVisible: false,
        handleAjouterInterlocuteurVisible: false,
        listeInterlocteursPotentiels: [],
        multipleSelection: [],
    

        optionsFonction: '',
        dialogInterlocuteur: {
            civilite: '1',
            prenom: '',
            nom: '',
            fonction: '',
            telFixe: '',
            telPortable: '',
            email: '',
            adr0: '',
            adr1: '',
            adr2: '',
            adr3: '',
            cp: '',
            pays: '',
            internet: '',
            fax: '',
            type: '1',
            inactif: '0',
            date_creat: '',
            date_MAJ: ''

        },
        // ------------------------ Onglet 3 -----------------------------
        listeTaches: '',
        taches_LIB: {
            taches_LIB_ID: []
        },
        taches_OBS: {
            taches_OBS_ID: []
        },
        taches_INT: {
            taches_INT_ID: []
        },
        taches_PRE: {
            taches_PRE_ID: []
        },
        taches_REA: {
            taches_REA_ID: []
        },
        optionsRessource:'',
        dialogFormTacheVisible: false,
        formTache: {
            Intervenant: '',
            tache: '',
            date_prev: '',
            date_real: '',
            observation: ''
        },
        dialogTache: {
            intervenant: '',
            tache: '',
            date_prev: new Date(),
            date_real: '',
            observation: ''
        },
        dialogImageUrl: '',
        dialogVisible: false,
        disabled: false,

        // ajout de documents
        fileList: [],
        theBlob: '',
        slectTacheCreate:'',
        index:-1,
        texteObs:'',
        RANGCourant:-1,
        select:'',
        listeTacheComplete:'',
        newDTE_REAL2:'',
        dteProch:'',
        detail_freq:'',
            
            
            }
            },
            computed: {

        
                        // a computed getter
                            // flitreAction: function () {
                            
                            //  }
            },
            methodes:{

           
            },
            created() {

                $.ajaxSetup({
                    data: {
                    'sessionId': this.$store.getters.sessionId,
                    },
                });
            
            var self= this
                var request = $.ajax({
                    url: BACKEND_URL+"controller/filtrer_Action.php",
                    async: false,
                    type: "POST",
                    data: {
                    'listeTAches':1
                    },
                    dataType: "html",
                    success: function(data) {
                        
                    
                        var dataParsed = JSON.parse(data)
                        
                        // self.tableData=dataParsed
                    

                    }
                })


            }
        }
</script>


